import React from 'react'

const NotFound = () => {
  return (
    <div className='not-found'>
        <h2>Hold your horses!</h2>
    </div>
  )
}

export default NotFound